import React, { Component } from "react";
import _isNumber from "lodash/isNumber";
import { getLinkedinIFrameUrl } from 'utils/Integrations'

import * as style from './style'

export default class LinkedinSection extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { endUser, companyName, companyUrl } = this.props
    const hasData = !!(companyName || companyUrl || endUser)

    return (
      <div>
        {hasData &&
          <div>
            <iframe
              src={getLinkedinIFrameUrl(endUser, companyName, companyUrl)}
              width="320"
              height="336"
              id="developer-specified-ID"
              frameBorder="0"
              type="text/html"
            />
        </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/LinkedinSection/index.js